import { z } from 'zod';
import { numberParameter } from './shared.js';

// Installed RELILLUM.SEQ, CODE V 2026 Update 0.1: RFD 21 32 1.25 0 "".
const relativeIlluminationSettings = z.strictObject({
  sample_points: z.number().int().nonnegative().default(21).describe("Number of native Y-field samples. The installed RELILLUM default is 21; zero and one retain CODE V's native failure behavior."),
  rays_across_diameter: z.number().int().nonnegative().default(32).describe('Native TRA_1FLD pupil-grid rays across the diameter. The installed RELILLUM default is 32; zero selects the native 20-ray default.'),
  pupil_overfill: z.number().finite().positive().default(1.25).describe('Native pupil overfill factor. The installed RELILLUM default is 1.25; CODE V can increase it with a warning for extreme negative vignetting.'),
});
export default {
  label: 'Relative Illumination', group: 'performance',
  description: "Relative illumination across the Y field, as a percentage of the brightest sampled point.",
  settingsSchema: relativeIlluminationSettings,
  parameters: [
    numberParameter('sample_points', 'Sample points', { integer: true }),
    numberParameter('rays_across_diameter', 'Rays across diameter', { integer: true }),
    numberParameter('pupil_overfill', 'Pupil overfill factor'),
  ],
  coverage: "Y fields only. Surfaces with no coating use CODE V's default single-layer quarter-wave MgF2 on air-glass surfaces, not bare glass; coatings set in your design are not carried over.",
} as const;
